import { Input } from '@/components/ui/input';

/**
 * Gallery form primitives — extracted from OpenCallPage so multiple public forms
 * (Open Call + Artist Intake + future) share identical visuals and validation feel.
 *
 * Style anchor:
 *   bg #050505, accent #90E0EF, font-mono labels, font-outfit headings,
 *   square edges (rounded-none), white focus ring.
 */

export function inputCls(error) {
  return `bg-transparent border ${error ? 'border-red-400' : 'border-[#333333]'} text-white rounded-none font-mono text-sm placeholder:text-[#555555] focus-visible:ring-white h-11`;
}

export function selectCls(error) {
  return `bg-transparent border ${error ? 'border-red-400' : 'border-[#333333]'} text-white rounded-none font-mono text-sm h-11 focus:ring-white`;
}

export function textareaCls(error) {
  return `w-full bg-transparent border ${error ? 'border-red-400' : 'border-[#333333]'} text-white rounded-none font-mono text-sm placeholder:text-[#555555] focus-visible:ring-white focus-visible:ring-1 focus-visible:outline-none p-3 resize-none`;
}

export function Field({ label, error, required, hint, children }) {
  return (
    <div>
      <label className="text-[10px] font-mono text-[#f6f6f6] tracking-[0.2em] uppercase block mb-2">
        {label}
        {required && <span className="text-[#90E0EF] ml-1">*</span>}
      </label>
      {children}
      {hint && !error && (
        <p className="text-[10px] font-mono text-[#555] mt-1.5 tracking-[0.05em]">{hint}</p>
      )}
      {error && (
        <p className="text-[11px] font-mono text-red-400 mt-1.5">{error}</p>
      )}
    </div>
  );
}

export function GalleryInput({ error, ...props }) {
  return <Input {...props} className={`${inputCls(error)} ${props.className || ''}`} />;
}

export function GalleryTextarea({ error, ...props }) {
  return <textarea {...props} className={`${textareaCls(error)} ${props.className || ''}`} />;
}

/** Cyan brand CTA button (public). */
export function GalleryCTAButton({ children, loading, disabled, ...rest }) {
  return (
    <button
      {...rest}
      disabled={loading || disabled}
      className={`open-call-btn w-full sm:w-auto rounded-none uppercase tracking-[0.15em] text-[11px] font-mono font-medium h-12 px-10 bg-[#90E0EF] text-black hover:bg-[#a8e8f4] transition-all duration-300 hover:shadow-[0_0_24px_rgba(144,224,239,0.35)] hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 disabled:hover:scale-100 disabled:hover:shadow-none ${rest.className || ''}`}
      style={{ cursor: loading || disabled ? 'wait' : 'pointer' }}
    >
      {children}
    </button>
  );
}

export function FormDivider() {
  return <div className="w-full h-px bg-[#222222] mb-12" />;
}

export const REQUIRED_MARK = (
  <span className="text-[#90E0EF] ml-1">*</span>
);

/** Validate email loosely. */
export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || '');
}
